export default {
  showCard: {
    cardShow: 'Account Upgrade',
    dingTalkStep1: 'Please log in to DingTalk using the mobile number you submitted in the previous step',
    dingTalkStep2: 'A team invitation from headquarters has been sent to you',
    dingTalkStep3: 'Accept the invitation to complete the account upgrade',
    agreedInvite: 'Already accepted the invitation? Try',
    complete: 'Complete',
    mergeAccount: 'Merge Accounts',
    addAgentAccountTip: 'Please add your Master Franchisee account',
    accountLabel: 'Account:',
    pleaseEnterAccount: 'Please enter your account',
    passwordLabel: 'Password:',
    pleaseEnterPassword: 'Please enter your password',
    addAccountBtn: 'Add Account',
    back: 'Back',
    upgradeSuccess: 'Account upgrade successful',
    upgradeSuccessTip: 'You can now log in from',
    upgradeSuccessTip2: 'to experience the upgraded features',
    loginWithNewAccount: 'Log in with new account',
    accountAlreadyAdded: 'This account has already been added. Please do not add it again',
    pleaseEnterAccountPassword: 'Please enter account and password',
    addSuccess: 'Added successfully',
    addFailed: 'Failed to add',
    refreshed: 'Refreshed',
    upgradeDetails: 'Upgrade/Downgrade Details',
    dealerParticipateTip: 'Master Franchisees participate in upgrade/downgrade assessments. For related metrics and rules, please refer to:',
    assessmentDetail: 'Assessment Details!',
    performanceShortfallKeep: 'Gap to maintain status',
    performanceShortfallUpgrade: 'Gap to upgrade',
    objectionSubmit: 'Submit Objection',
    advertiseMessage: 'Announcements',
    setEmergencyContact: 'Set Emergency Contact',
    viewDetail: 'View Details',
    downloadAttachment: 'Download Attachment',
    objectionContent: 'Objection Content',
    viewObjectionContent: 'View Objection Content',
    objectionContentLabel: 'Objection Content:',
    objectionPlaceholder: 'Please enter your objection regarding the announcement',
    close: 'Close',
    noAttachment: 'No attachments for this announcement',
    download: 'Download',
    viewNoticeDetail: 'View Announcement Details',
    giveUpRights: 'Give Up Benefits',
    skip: 'Skip >',
    pleaseEnterPhoneForRecovery: 'Please enter your account mobile number for password recovery',
    pleaseEnterValidPhone: 'Please enter a valid mobile number',
    pleaseEnterVerifyCode: 'Please enter the verification code',
    verifyCodeFormatError: 'Invalid verification code format',
    pleaseEnterPhone: 'Please enter mobile number',
    sendSuccess: 'Sent successfully',
    requestFailed: 'Request failed',
    operationFailed: 'Operation failed',
    closeWithCountdown: 'Close ({n}s)',
    objectionContact: 'If you have any objections, please contact me',
    objectionLengthTip: 'Please enter 10–100 characters for your objection',
    submitSuccess: 'Submitted successfully',
    submitFailed: 'Submission failed',
    commodityRatioMsg: 'Product Allocation Ratio',
    autoOrderRatioTitle: 'Auto Order Product Ratio Settings',
    agentId: 'Master Franchisee ID:',
    ratioTip: '*Please accurately maintain the ratio for each model. Orders will be automatically allocated based on these ratios. The total must equal 100%',
    modelName: 'Product Model',
    ratio: 'Ratio',
    ratioTotal: 'Total',
    pleaseEnterRatio: 'Please enter ratio',
    updateLog: 'Update Log:',
    ratioValidationError: 'Please enter valid ratios (integers from 1 to 100), and ensure the total equals 100%',
    saveSuccess: 'Saved successfully',
    saveFailed: 'Save failed',
    noticeTitle: 'Announcement Title',
    pleaseEnterNoticeTitle: 'Please enter announcement title',
    noticeType: 'Announcement Type',
    pleaseSelectNoticeType: 'Please select announcement type',
    urgencyLevel: 'Priority',
    pleaseSelectUrgencyLevel: 'Please select priority',
    readStatus: 'Status',
    pleaseSelectStatus: 'Please select status',
    sendTime: 'Sent Time',
    readTime: 'Read Time',
    studentAccount: 'Student Account',
    studentName: 'Student Name',
    campusId: 'Learning Center ID',
    campusName: 'Learning Center Name',
    performanceType: 'Performance Type',
    q1Performance: 'Q1 Performance',
    q2Performance: 'Performance up to Q2',
    q2Remark: '(including Q1)',
    q3Performance: 'Performance up to Q3',
    q3Remark: '(including Q1 and Q2)',
    q4Performance: 'Performance up to Q4',
    q4Remark: '(including Q1, Q2, and Q3)',
    upgradeGap: 'Gap to upgrade',
  },
}
